// FormularioNotificaciones.js
import React, { useState, useEffect } from "react";
import { Form, Button, Table, Badge, ButtonGroup } from "react-bootstrap";

const FormularioNotificaciones = ({ enviarNotificacion }) => {
  const [texto, setTexto] = useState("");
  const [asunto, setAsunto] = useState("");
  const [fecha, setFecha] = useState("");
  const [tipo, setTipo] = useState("normal");
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState("");
  const [usuarios, setUsuarios] = useState([]);
  const [solicitudes, setSolicitudes] = useState([]);
  const [solicitudSeleccionada, setSolicitudSeleccionada] = useState("");
  const [fileBase64, setFileBase64] = useState("");
  const [nombreDocumento, setNombreDocumento] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [notificaciones, setNotificaciones] = useState([]);
  const [modoFormulario, setModoFormulario] = useState(true);

  useEffect(() => {
    getUsuarios();
    fetchNotificaciones();
  }, []);

  const getHeaders = () => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  });

  const getUsuarios = async () => {
    try {
      const response = await fetch("https://sectorb12.info/api/usuarios", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (response.ok) setUsuarios(await response.json());
    } catch (error) {
      console.error("Error al hacer la solicitud:", error);
    }
  };

  const fetchNotificaciones = async () => {
    try {
      const response = await fetch("https://sectorb12.info/api/notificaciones", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (response.ok) setNotificaciones(await response.json());
    } catch (error) {
      console.error("Error al obtener notificaciones:", error);
    }
  };

  const getSolicitudes = async (value) => {
    setUsuarioSeleccionado(value);
    setSolicitudSeleccionada("");
    try {
      const response = await fetch(
        `https://sectorb12.info/api/solicitudes/usuarios/${value}`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      if (response.ok) setSolicitudes(await response.json());
      else setSolicitudes([]);
    } catch {
      setSolicitudes([]);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setNombreDocumento(file.name);
      const reader = new FileReader();
      reader.onload = () => setFileBase64(reader.result.split(",")[1]);
      reader.readAsDataURL(file);
    }
  };

  const sendDocument = async (usuarioId) => {
    try {
      const response = await fetch("https://sectorb12.info/api/documentos", {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify({
          NombreDocumento: nombreDocumento,
          Documento: fileBase64,
          usuario_id: usuarioId,
        }),
      });
      if (response.ok) {
        const result = await response.json();
        return result.DocumentoID;
      }
      alert("Error al guardar el documento.");
      return null;
    } catch {
      alert("No se pudo conectar con la base de datos.");
      return null;
    }
  };

  const publicarNotificacion = async (formData) => {
    try {
      const response = await fetch("https://sectorb12.info/api/notificaciones", {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify({
          UsuarioID: formData.usuarioId,
          SolicitudID: formData.solicitudId || null,
          FechaEnvio: formData.fecha,
          FechaRecepcion: null,
          Recepcion: false,
          Firmado: false,
          FechaFirma: null,
          Asunto: formData.asunto,
          Descripcion: formData.texto,
          DocumentoID: formData.documentoId,
          Tipo: formData.tipo,
        }),
      });
      if (!response.ok) throw new Error();
      alert("Notificación publicada con éxito.");
      fetchNotificaciones();
    } catch {
      alert("Hubo un error al publicar la notificación.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!asunto || !texto || !fecha || !usuarioSeleccionado) {
      alert("Por favor, complete todos los campos requeridos.");
      return;
    }
    setEnviando(true);
    const docId = await sendDocument(usuarioSeleccionado);
    if (!docId) { setEnviando(false); return; }

    await publicarNotificacion({
      texto, asunto, fecha, tipo,
      usuarioId: usuarioSeleccionado,
      solicitudId: solicitudSeleccionada,
      documentoId: docId,
    });

    setTexto(""); setAsunto(""); setFecha(""); setTipo("normal");
    setUsuarioSeleccionado(""); setSolicitudes([]); setSolicitudSeleccionada("");
    setNombreDocumento(""); setFileBase64("");
    setEnviando(false);
  };

  const renderBadgeTipo = (tipo) => {
    const map = { normal: "secondary", subsanacion: "warning", justificante: "info" };
    const labels = { normal: "Normal", subsanacion: "Subsanación", justificante: "Justificante" };
    return <Badge bg={map[tipo] || "secondary"}>{labels[tipo] || tipo}</Badge>;
  };

  return (
    <div>
      <ButtonGroup className="mb-4">
        <Button variant={modoFormulario ? "success" : "outline-success"} onClick={() => setModoFormulario(true)}>
          Crear Notificación
        </Button>
        <Button variant={!modoFormulario ? "success" : "outline-success"} onClick={() => setModoFormulario(false)}>
          Ver Histórico
        </Button>
      </ButtonGroup>

      {modoFormulario ? (
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="usuario">
            <Form.Label>Seleccione un usuario</Form.Label>
            <Form.Control
              className="mb-3"
              as="select"
              value={usuarioSeleccionado}
              onChange={(e) => getSolicitudes(e.target.value)}
            >
              <option value="">Seleccione un usuario</option>
              {usuarios.map((u) => (
                <option key={u.UsuarioID} value={u.UsuarioID}>
                  {u.Nombre} {u.Apellidos}
                </option>
              ))}
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="tipo" className="mb-3">
            <Form.Label>Tipo de notificación</Form.Label>
            <Form.Select value={tipo} onChange={(e) => setTipo(e.target.value)}>
              <option value="normal">Normal</option>
              <option value="subsanacion">Subsanación — requiere documentación adicional</option>
            </Form.Select>
            {tipo === "subsanacion" && (
              <Form.Text className="text-warning fw-semibold">
                <i className="bi bi-exclamation-triangle me-1"></i>
                El usuario podrá adjuntar documentos adicionales en respuesta a esta notificación.
              </Form.Text>
            )}
          </Form.Group>

          <Form.Group controlId="asunto">
            <Form.Label>Asunto</Form.Label>
            <Form.Control
              type="text"
              value={asunto}
              onChange={(e) => setAsunto(e.target.value)}
              placeholder="Ejemplo: Revisión de solicitud, Subsanación, etc."
            />
          </Form.Group>

          {solicitudes.length > 0 && (
            <Form.Group controlId="solicitud">
              <Form.Label className="mt-3">Asociar a una solicitud (opcional)</Form.Label>
              <Form.Control
                className="mb-2"
                as="select"
                value={solicitudSeleccionada}
                onChange={(e) => setSolicitudSeleccionada(e.target.value)}
              >
                <option value="">-- Ninguna --</option>
                {solicitudes.map((s) => (
                  <option key={s.SolicitudID} value={s.SolicitudID}>
                    {s.Descripcion}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          )}

          <Form.Group controlId="texto">
            <Form.Label className="mt-3">Texto de Notificación</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={texto}
              onChange={(e) => setTexto(e.target.value)}
              placeholder="Escribe aquí el texto de la notificación..."
            />
          </Form.Group>

          <Form.Group controlId="fecha" className="mt-3">
            <Form.Label>Fecha</Form.Label>
            <Form.Control
              type="date"
              value={fecha}
              onChange={(e) => setFecha(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="archivo" className="mt-3">
            <Form.Label>Archivo Adjunto</Form.Label>
            <Form.Control type="file" onChange={handleFileChange} />
          </Form.Group>

          {usuarioSeleccionado && (
            <Button variant="success" type="submit" className="mt-4 w-100" disabled={enviando}>
              {enviando ? "Enviando..." : "Enviar Notificación"}
            </Button>
          )}
        </Form>
      ) : (
        <>
          <h5>Histórico de Notificaciones</h5>
          <Table striped bordered hover responsive className="mt-3">
            <thead>
              <tr>
                <th>Usuario</th>
                <th>Asunto</th>
                <th>Tipo</th>
                <th>Fecha de Envío</th>
                <th>Estado</th>
                <th>Fecha de Firma</th>
              </tr>
            </thead>
            <tbody>
              {notificaciones.map((n) => (
                <tr key={n.NotificacionID}>
                  <td>{n.UsuarioID}</td>
                  <td>{n.Asunto || "—"}</td>
                  <td>{renderBadgeTipo(n.Tipo)}</td>
                  <td>{new Date(n.FechaEnvio).toLocaleDateString()}</td>
                  <td>
                    <Badge bg={n.Firmado ? "success" : "warning"}>
                      {n.Firmado ? "Firmada" : "Pendiente"}
                    </Badge>
                  </td>
                  <td>{n.FechaFirma ? new Date(n.FechaFirma).toLocaleDateString() : "—"}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      )}
    </div>
  );
};

export default FormularioNotificaciones;